import { lazy } from 'react';

const ThunderbitePage = lazy(() => import(/* webpackChunkName: "thunderbite" */ './thunderbite-page.js'));

export default ThunderbitePage;
